var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.categories,"value":_vm.value},on:{"input":_vm.selectChange}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }